<template>
  <div class="assessment_main">
    <div class="assessment_title">
      <h2>社交电商</h2>
    </div>
    <ul v-if="productFlag==3">
      <li v-if="isStudent||$_has('zledu.gxzx.zhsxappds:ds')">
        <img src="../img/ds-logo.png" alt="" class="app_logo">
        <img src="../img/znsj-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('ds')">进入系统</el-button>
      </li>
    </ul>
  </div>
</template>
<script>
  import crypto from 'crypto'
  import {Base64} from 'js-base64';
  import * as userApi from '../../../../api/userApi'
  import axios from 'axios'

  export default {
    data() {
      return {
        sysUserPermissionList: JSON.parse(localStorage.getItem('sysUserPermissionList')) || [], // 权限对象
        userType: sessionStorage.getItem('userType'), //用户身份
        isStudent: false,
        productFlag: sessionStorage.getItem('productFlag'),
      };
    },
    created() {
      if (this.userType == 2 || this.userType == 3) {
        this.isStudent = true
      } else {
        this.isStudent = false
      }
    },
    methods: {
      setSha1(url, secretKey) {
        /** 加密 */
        let hmac = crypto.createHmac('sha1', secretKey || '123456');
        hmac.update(url);
        return hmac.digest('hex');
      },
      entrySys(sys) {
        let that = this
        if (localStorage.getItem('Authorization')) {
          userApi.isExpired(localStorage.getItem('Authorization')).then(rs => {
            if (rs.code == 0 && rs.data == 0) {
              let userId = sessionStorage.getItem('userId')
              let courseId = userId + "8888"
              let classId = userId + "9999"
              let qstId = userId + "7777"
              let clientId = '1349883712819109890'
              let encrypted = `TEACH_${courseId}_${classId}_2_NONE`
              let identity = 'dszh'
              // let item=${questionDto.questionCode}
              let item = '27011201-6fe9-46b4-ba7f-fe241aed2132'
              let roleCodes = "3001"
              let templateCode = ''
              let timestamp = new Date().getTime();
              let token = localStorage.getItem("Authorization")
              let userType = sessionStorage.getItem("userType")
              let username = sessionStorage.getItem("userName")
              let nickname = sessionStorage.getItem("loginName")


              // 加密参数
              let shanStr = `{clientId=${clientId}, encrypted=${encrypted}, identity=${identity}, item=${item}, qstId=${qstId}, roleCode=${roleCodes}, templateCode=${templateCode}, timeStamp=${timestamp}, token=${token}, userType=${userType}, username=${username}}`;
              let secretKey = that.setSha1(shanStr, '02424D4FD04A007E453DADA28E4EEE37')
              let dsParams = {
                clientId: clientId,
                encrypted: encrypted,
                identity: identity,
                item: item,
                qstId: qstId,
                roleCode: roleCodes,
                sign: secretKey,
                templateCode: templateCode,
                timeStamp: timestamp,
                token: token,
                userId: userId,
                userType: userType,
                username: username,
              }
              if (sys === 'ds') {
                that.zljtLogin(dsParams).then((rs) => {
                  if (rs.data.code == 0) {
                    let dsParam = {
                      token: rs.data.data.access_token,
                      gxzxToken: token,
                      userId: userId,
                      isTeamShare: 0,
                      keyId: "0000",
                      roleCode: roleCodes,
                      templateCode: templateCode,
                      sourceId: encrypted,
                      menuCode: "ALL",
                      id: qstId,
                      nickname: Base64.encode(nickname)
                    }
                    let dsParamStr = ""
                    for (let key in dsParam) {
                      dsParamStr += (key + "=" + dsParam[key] + "&")
                    }
                    let jumpStr = dsParamStr.substring(0, dsParamStr.length - 1)
                    let src = `${process.env.DS_API}/#/?${Base64.encode(jumpStr)}`
                    window.open(src)
                  } else {
                    that.$messageError(rs.data.msg)
                  }
                })
              } else {
                this.loading = false
                this.$messageWarning('暂无权限，请联系管理员！')
              }
            } else {
              this.$router.push({path: '/home'})
              this.$messageError('登录已过期，请重新登录')
              localStorage.removeItem('Authorization')
              localStorage.removeItem('isbinding')
            }
          }).catch(err => {
            console.log(err)
          })
        } else {
          this.loading = false
          this.$router.push({path: '/home'})
        }
      },
      zljtLogin(params) {
        let src = `${process.env.ZLJT_API}/api-oauth/v1/oauth/v2/oauth/token`
        return axios.post(src, params).then(rs => rs)
      },
    }
  }
</script>
<style lang="scss" scoped>
  .assessment_main {
    .assessment_title {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #5397f7;

      h2 {
        border-left: 2px solid #5397f7;
        color: #5397f7;
        font-size: 14px;
        padding-left: 4px;
        line-height: 10px;
      }
    }

    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        width: 278px;
        height: 180px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
        border-radius: 4px;
        position: relative;
        margin-top: 24px;
        margin-right: 40px;

        .app_logo {
          position: absolute;
          left: 40px;
          top: 48px;
          z-index: 2;
          height: 22px;
        }

        .app_bg {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          width: 278px;
          height: 180px;
        }

        button {
          position: absolute;
          left: 40px;
          bottom: 24px;
          z-index: 2;
          width: 96px;
          height: 34px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(83, 151, 247, 1);
          border-radius: 4px;
          padding: 0;
          color: #5397F7;

          &:hover {
            background: #5397F7;
            color: #fff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/appCenter/components/socialmall.vue